import { FileDown, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { STATUS, brl } from "../../lib/data";
import { fmtDate } from "../../lib/pricing";

export const StatusBadge = ({ status }) => {
  const s = STATUS[status] || STATUS.aguardando_pagamento;
  return <span className={`inline-block whitespace-nowrap rounded-full border px-2.5 py-1 text-xs ${s.cls}`}>{s.label}</span>;
};

export const StatusSelect = ({ value, onChange, testid }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testid} className="h-9 w-[190px] bg-white/5 border-white/10 text-white text-xs"><SelectValue /></SelectTrigger>
    <SelectContent className="bg-[#111219] border-white/10 text-white">
      {Object.entries(STATUS).map(([k, v]) => <SelectItem key={k} value={k} className="text-xs focus:bg-[#FFD200] focus:text-[#08080C]">{v.label}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const clientWa = (b) => {
  const digits = (b?.client_phone || "").replace(/\D/g, "");
  const num = digits.startsWith("55") ? digits : `55${digits}`;
  const msg = `Olá, ${b?.client_name?.split(" ")[0] || ""}! Aqui é da Play Toys sobre seu evento em ${fmtDate(b?.event_date)}.`;
  return `https://wa.me/${num}?text=${encodeURIComponent(msg)}`;
};

const Item = ({ k, v }) => (
  <div><p className="font-mono text-[11px] uppercase tracking-[0.15em] text-zinc-400">{k}</p><p className="text-white text-sm mt-1 break-words">{v || "—"}</p></div>
);

const downloadContract = async (cid) => {
  try {
    const res = await api.get(`/admin/contracts/${cid}/pdf`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `contrato-playtoys-${cid}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  } catch (e) { toast.error("Não foi possível baixar o contrato."); }
};

export const BookingDetail = ({ booking: b, onClose }) => (
  <Dialog open={!!b} onOpenChange={(o) => !o && onClose()}>
    <DialogContent data-testid="admin-booking-detail" className="max-w-2xl bg-[#111219] border-white/10 text-white max-h-[90vh] overflow-y-auto">
      <DialogTitle className="font-display text-xl">{b?.client_name}</DialogTitle>
      {b && (
        <div className="grid sm:grid-cols-2 gap-5 mt-2">
          <Item k="Status" v={<StatusBadge status={b.status} />} />
          <Item k="Pacote" v={`${b.package_name} + ${b.extra_plushies} extras`} />
          <Item k="Data / horário" v={`${fmtDate(b.event_date)} · ${b.event_time}`} />
          <Item k="Cidade" v={`${b.city}/ES`} />
          <Item k="Endereço" v={b.address} />
          <Item k="CPF/CNPJ" v={b.client_document} />
          <Item k="WhatsApp" v={b.client_phone} />
          <Item k="E-mail" v={b.client_email} />
          <Item k="Pagamento" v={`${b.payment_option === "full" ? (b.payment_method === "pagarme" ? "Integral" : "Integral (5% off)") : "Sinal 30%"} · ${b.payment_method === "pagarme" ? "Pagar.me cartão parcelado" : "Stripe (Pix/cartão à vista)"}`} />
          <Item k="Juros pagos pelo cliente" v={b.interest_paid ? brl(b.interest_paid) : "—"} />
          <Item k="Total" v={brl(b.total)} />
          <Item k="Pago" v={brl(b.amount_paid)} />
          <Item k="Saldo" v={`${brl(b.total - b.amount_paid)}${b.remaining_due_date ? ` até ${fmtDate(b.remaining_due_date)}` : ""}`} />
          <div className="sm:col-span-2"><Item k="Observações" v={b.notes} /></div>
          <Item k="Local / convidados" v={b.venue_name ? `${b.venue_name} · ${b.guests} convidados` : ""} />
          <Item k="Condições de acesso" v={b.access_details} />
          <Item k="Contrato" v={b.contract_id || "Sem contrato (reserva anterior ao aceite digital)"} />
          {b.contract_id && (
            <button type="button" onClick={() => downloadContract(b.contract_id)} data-testid="admin-download-contract"
              className="inline-flex justify-center items-center gap-2 rounded-full border border-[#FFD200] text-[#FFD200] font-semibold py-3 hover:bg-[#FFD200] hover:text-[#08080C]"><FileDown className="w-4 h-4" /> Baixar contrato (PDF)</button>
          )}
          <a href={clientWa(b)} target="_blank" rel="noreferrer" data-testid="admin-detail-whatsapp"
            className="sm:col-span-2 inline-flex justify-center items-center gap-2 rounded-full bg-[#25D366] text-white font-semibold py-3"><MessageCircle className="w-4 h-4" /> Chamar no WhatsApp</a>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
